import React from 'react';
import { Svg } from '../../Svg/Svg';

interface SelectOption {
  value: string;
  label: string;
  [key: string]: any;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  id?: string;
  value?: string;
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  options: SelectOption[];
  errorMessage?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select: React.FC<SelectProps> = ({
  name,
  id,
  value = '',
  label,
  placeholder = '',
  isRequired,
  options = [],
  errorMessage,
  onChange,
  ...otherProps
}) => {
  return (
    <div className="mz-form-item mz-form-item--select">
      {label && (
        <label className="mz-form-item__label shrink" htmlFor={id}>
          {label}{isRequired && <span className="mz-form-item__required-star">*</span>}
        </label>
      )}
      <select
        className="mz-form-item__select"
        name={name}
        id={id}
        required={isRequired}
        value={value}
        onChange={onChange}
        {...otherProps}
      >
        {placeholder && (
          <option value="" hidden={isRequired} disabled={isRequired}>{placeholder}</option>
        )}
        {options.map(({ value, label, ...rest }) => (
          <option key={value} value={value} {...rest}>
            {label.replace('&nbsp;', ' ')}
          </option>
        ))}
      </select>
      <div className="mz-form-item__arrow-down">
        <Svg
          type="chevron_small_down"
          size={0.75}
          colour="grey"
        />
      </div>
      {errorMessage && (
        <div className="mz-form-item__error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default Select;
